<template>
	<div class='text-center'>
		<v-dialog
			v-model='show'
			max-width='600'
			persistent
			@input='(v) => v || closeModal()'
			content-class='post-filter-modal'
		>
			<v-card class='post-filter-modal__card'>
				<div class='d-flex align-center flex-wrap'>
					<div class='post-filter-modal__title'>
						{{ capitalizeActiveButton }}
						<div class="post-filter-modal__progress d-flex justify-center align-center py-6" v-if="isFiltersLoading">
							<v-progress-circular indeterminate :size="25" :width="3"></v-progress-circular>
						</div>
					</div>
				</div>

				<div class='post-filter-modal__container mb-8 mt-3' ref="filterContainer" @scroll="handleScroll">

					<div
						v-if="selectedButton.includes('chapters') && currentActiveButton === 'chapters'"
						class='pl-4 pb-3'
					>
						<div
							class='checkbox-container'
							v-for='item in chapters'
							:key='item.chapter_id'
						>
							<v-checkbox
								:label='item.chapter_name'
								:color='buttonColor'
								:value='item.chapter_id'
								@change="$emit('setItems', {
									listItem: item,
									selectedType: 'selectedChapters',
									idColumnName: 'chapter_id'
								})"
								hide-details
							></v-checkbox>
						</div>
					</div>

					<div
						v-if="selectedButton.includes('tags') && currentActiveButton === 'tags'"
						class='ml-4 pb-3'
					>
						<div
							class='checkbox-container'
							v-for='item in tags'
							:key='item.tag_id'
						>
							<v-checkbox
								:label='item.tag'
								:color='buttonColor'
								:value='item.tag_id'
								@change="$emit('setItems', {
									listItem: item,
									selectedType: 'selectedTags',
									idColumnName: 'tag_id'
								})"
								hide-details
							></v-checkbox>
						</div>
					</div>

					<div
						v-if="selectedButton.includes('category') && currentActiveButton === 'category'"
						class='pl-4 pb-3 mt-3'
					>
						<v-radio-group>
							<v-radio
								v-for='category in normalizeCategories'
								:label='category.name'
								:key='category.id'
								:color='buttonColor'
								class="mt-3"
								:value='category.id'
								@change="$emit('setCategory', {category})"
							></v-radio>
						</v-radio-group>
					</div>

					<div
						v-if="filtersCustomList.some(chapter => chapter === currentActiveButton)"
						class='ml-4 pb-3'
					>
						<div
							class='checkbox-container'
							v-for="item in chipsList"
							:key='item.id'
						>
							<v-checkbox
								:label='item.val'
								:color='buttonColor'
								:value='item.id'
								@change="value => handleChange(item, value)"
								hide-details
							></v-checkbox>
						</div>
					</div>

					<div
						class="d-flex flex-column mb-4 mt-4"
						v-if="selectedButton.includes('date') && currentActiveButton === 'date'"
					>
						<v-card-text class='px-0 py-0'>
							<v-tabs fixed-tabs class="date-time-control-tabs mb-6" v-model='activeDateTab'>

								<v-tab key='fixedPeriods'>
									<slot name='dateIcon'>
										<span>Fixed period</span>
									</slot>
								</v-tab>

								<v-tab key='datePicker'>
									<slot name='dateIcon'>
										<span>Date Picker</span>
									</slot>
								</v-tab>

								<v-divider class='mb-4 d-block'></v-divider>

								<v-tab-item key='fixedPeriods'>
									<v-radio-group v-model="selectedOption" class="ml-4">
										<v-radio
											key="today"
											label="Today"
											value="today"
											:color='datePickerColor'
											class="mb-4"
										></v-radio>

										<v-radio
											key="yesterday"
											label="Yesterday"
											value="yesterday"
											:color='datePickerColor'
											class="mb-4"
										></v-radio>

										<v-radio
											key="last7days"
											label="Last 7 days"
											value="last7days"
											:color='datePickerColor'
											class="mb-4"
										></v-radio>

										<v-radio
											key="last30days"
											label="Last 30 days"
											value="last30days"
											:color='datePickerColor'
											class="mb-4"
										></v-radio>

										<v-radio
											key="thisMonth"
											label="This month"
											value="thisMonth"
											:color='datePickerColor'
											class="mb-4"
										></v-radio>

										<v-radio
											key="lastMonth"
											label="Last Month"
											value="lastMonth"
											:color='datePickerColor'
											class="mb-4"
										></v-radio>
									</v-radio-group>
								</v-tab-item>

								<v-tab-item key='datePicker'>
									<slot name='timeIcon'>
										<v-date-time-picker
											label="Start filter date: "
											type='from'
											v-model="selectedTime"
											dialogWidth='500'
											okText='Apply'

											:error='error'
											:show-error='showError'
											:close-alert='closeAlert'

											:datePickerProps="{color: datePickerColor}"
											:timePickerProps="{color: datePickerColor}"
											:setItems='setItemsHandler'
										> </v-date-time-picker>

										<v-date-time-picker
											label="End filter date: "
											type='to'
											v-model="selectedTime"
											dialogWidth='500'

											:error='error'
											:show-error='showError'
											:close-alert='closeAlert'

											:datePickerProps="{color: datePickerColor}"
											:timePickerProps="{color: datePickerColor}"
											okText='Apply'
											:setItems='setItemsHandler'
										> </v-date-time-picker>
									</slot>
								</v-tab-item>

							</v-tabs>
						</v-card-text>
					</div>
				</div>

				<div class="mt-4 post-filter-modal__action-btn-wrapper">
					<v-btn
						class='elevation-0 post-filter-modal__action-btn action-cancel'
						outlined
						@click='closeModal'
					>
						Cancel
					</v-btn>

					<v-btn
						class='post-filter-modal__action-btn action-apply'
						:loading='false'
						:disabled='false'
						@click="$emit('applySelection')"
					>
						Apply
					</v-btn>
				</div>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import _ from 'lodash'
import DatetimePicker from '@/components/Modals/DatetimePicker.vue'
import Vue from 'vue'
import {startOfMonth, endOfMonth, sub} from 'date-fns'

Vue.component('v-date-time-picker', DatetimePicker);

export default {
	props: {
		chipsLists: {
			type: Object,
			default: () => {}
		},
		currentActiveButtonTitle: {
			type: String,
			default: '',
		},
		selectedButton: {
			type: Array,
			default: () => ['clear'],
		},
		currentActiveButton: {
			type: String,
			default: '',
		},
		closeAlert: {
			type: [Function],
			default: () => {}
		},
		show: {
			type: Boolean,
			default: false,
		},
		error: {
			type: String,
			default: ''
		},
		showError: {
			type: Boolean,
			default: false
		},
		entityType: {
			type: String,
			default: 'threads'
		}
	},

	watch: {
		selectedOption(option) {
			let fromDate = '';
			let fromTime = '';

			let toDate = '';
			let toTime = '';
			const currentDate = new Date();

			switch(option) {
				case 'today':
					fromDate = this.generateAndFormatDate(currentDate)
					toDate = this.generateAndFormatDate(currentDate)

					break;
				case 'yesterday':
					const yesterday = sub(currentDate, { days: 1 })

					fromDate = this.generateAndFormatDate(yesterday)
					fromTime = '00:00'

					toDate = this.generateAndFormatDate(yesterday)
					toTime = '23:59'

					break;
				case 'last7days':
					const last7DaysFrom = sub(currentDate, { days: 6 });

					fromDate = this.generateAndFormatDate(last7DaysFrom)
					toDate = this.generateAndFormatDate(currentDate)
					break;
				case 'last30days':
					const last30DaysTo = currentDate;
					const last30DaysFrom = sub(last30DaysTo, { days: 29 });

					fromDate = this.generateAndFormatDate(last30DaysFrom)
					toDate = this.generateAndFormatDate(last30DaysTo)

					break;
				case 'thisMonth':
					const startThisMonth = startOfMonth(currentDate);
					const endThisMonth = endOfMonth(currentDate);

					fromDate = this.generateAndFormatDate(startThisMonth)
					toDate = this.generateAndFormatDate(endThisMonth)

					break;
				case 'lastMonth':
					const endDate = sub(currentDate, { months: 1 });
					const startLastMonth = startOfMonth(endDate);
					const endLastMonth = endOfMonth(endDate);

					fromDate = this.generateAndFormatDate(startLastMonth)
					toDate = this.generateAndFormatDate(endLastMonth)

					break;
				default:
					fromDate = this.generateAndFormatDate(new Date())
					toDate = this.generateAndFormatDate(new Date())

			}

			this.$emit('setDate', this.normalizeDateTime(fromDate, '00:00', 'from'));
			this.$emit('setDate', this.normalizeDateTime(toDate, '23:59', 'to'));
		},
		currentActiveButton(newValue) {
			if (newValue === 'tags') {
				if (this.tags.length === 0) {
					this.page = 1
					this.fetchTags({ filter: this.$props.entityType })
				} else {
					this.page = +this.tagsMeta.currentPage
				}
			} else if (newValue === 'category') {
				if (this.categories.length === 0) {
					this.page = 1
					this.fetchEventCategories()
				} else {
					this.page = +this.categoriesMeta.currentPage
				}
			} else if (newValue !== 'clear' && this.filtersCustomList.some(chapter => chapter === newValue) && this.isUsersOrDirectoryPage) {
				let activeButton = newValue === 'employment_types' ? 'employment-types' : newValue
				if (!this.lists || this.lists && !this.lists[activeButton]) {
					this.page = 1
					this.getList({ name: activeButton })
				} else {
					this.page = +this.listsPageMeta[activeButton].pageCount || 1
				}
			}
		},
		tags() {
			this.clearTimer()
		},
		categories() {
			this.clearTimer()
		},
		isListsLoading(newValue) {
			!newValue && this.clearTimer()
		}
	},

	methods: {
		...mapActions('settings', ['fetchChapters']),
		...mapActions('tag', ['fetchTags', 'clearTags']),
		...mapActions('event', ['fetchEventCategories', 'clearEventCategories']),
		...mapActions('list', ['getList', 'getListsMeta']),

		closeModal() {
			this.$emit('closeModal')
		},
		setItemsHandler(dateTime) {
			this.$emit('setDate', dateTime);
		},
		normalizeDateTime(date, time, type) {
			return { date, time, type }
		},
		pad(number) {
			return (number < 10 ? '0' : '') + number;
		},
		generateAndFormatDate(date) {
			const year = date.getFullYear();
			const month = this.pad(date.getMonth() + 1 );
			const day = this.pad( date.getDate() );

			return year + '-' + month + '-' + day;
		},
		handleScroll() {
			if (!this.scrollTimer) {
				const container = this.$refs.filterContainer;
				if (container.scrollTop + container.clientHeight >= container.scrollHeight) {
					if (!this.isFiltersLoading && !this.isLastPage) {
						const page = +this.page + 1
						this.page = page
						this.scrollTimer = setTimeout(() => {
							this.currentActiveButton === 'tags' &&
							this.fetchTags({ filter: this.$props.entityType, page});
							this.currentActiveButton === 'category' &&
							this.fetchEventCategories({page})
							if (this.isUsersOrDirectoryPage) {
								this.getList({name: this.currentActiveButton === 'employment_types' ? 'employment-types' : this.currentActiveButton, query: {page}})
							}
						}, 500)
					}
				}
			}
		},
		clearTimer() {
			clearTimeout(this.scrollTimer)
			this.scrollTimer = null
		},
		itemSelectedType() {
			switch (this.currentActiveButton) {
				case 'employment_types':
					return 'selectedEmploymentTypes'
				case 'is_member':
					return 'selectedIsMember'
				case 'dir_index_column1':
					return 'selectedDirIndexColumn1'
				case 'index_column1':
					return 'selectedIndexColumn1'
				case 'dir_index_column2':
					return 'selectedDirIndexColumn2'
				case 'index_column2':
					return 'selectedIndexColumn2'
				case 'dir_index_column3':
					return 'selectedDirIndexColumn3'
				case 'index_column3':
					return 'selectedIndexColumn3'
			}
		},
		handleChange(item, value) {
			if (value) {
				this.$emit('setItems', {
					listItem: item,
					selectedType: this.itemSelectedType()
				})
			}
		}
	},

	data() {
		return {
			date: '',
			selectedTime: '',
			activeDateTab: 'fixedPeriods',
			selectedOption: '',
			scrollTimer: null,
			page: 1,
			filtersCustomList: ['index_column1', 'employment_types', 'is_member', 'dir_index_column1', 'dir_index_column2', 'dir_index_column3']
		}
	},

	computed: {
		...mapGetters('auth', ['profile']),
		...mapGetters('event', ['categories', 'isLoading', 'categoriesMeta', 'isCategoriesLoading', 'isCategoriesLoading']),
		...mapGetters('settings', ['styles', 'chaptersList']),
		...mapGetters('tag', ['tags', 'isTagsLoading', 'tagsMeta']),
		...mapGetters('list', ['listsPageMeta', 'isListsLoading', 'lists']),

		chapters() {
			if (this.profile && this.profile.chapters.length > 0) {
				return this.profile.chapters.filter(item => !item.hidden_subgroup)
			}

			return []
		},
		chipsList() {
			const activeButton = this.currentActiveButton === 'employment_types' ? 'employment-types' : this.currentActiveButton
			return this.lists && this.lists[activeButton] ? this.lists[activeButton] : []
		},
		capitalizeActiveButton() {
			return _.capitalize(this.$props.currentActiveButtonTitle)
		},
		datePickerColor() {
			const {
				navigation_bar_tint: navigationBarTint,
			} = this.styles || {}

			return navigationBarTint + ' !important'
		},

		buttonColor() {
			const {
				navigation_bar_tint: navigationBarTint,
			} = this.styles || {}

			return navigationBarTint + ' !important'
		},

		normalizeCategories() {
			return this.categories.map(({ category_id, category_name }) => {
				return {
					id: category_id,
					name: category_name,
				}
			})
		},
		isLastPage() {
			let activeButton = this.currentActiveButton
			if (activeButton === 'tags') {
				return this.tagsMeta && this.tagsMeta.pageCount <= this.page
			} else if (activeButton === 'category') {
				return this.categoriesMeta && this.categoriesMeta.pageCount <= this.page
			} else {
				activeButton = activeButton === 'employment_types' ? activeButton.replace('_', '-') : activeButton
				return this.listsPageMeta && this.listsPageMeta[activeButton] && +this.listsPageMeta[activeButton].pageCount <= this.page
			}
		},
		isFiltersLoading() {
			return this.isCategoriesLoading || this.isTagsLoading || this.isListsLoading
		},
		isUsersOrDirectoryPage() {
			return this.$route.name === 'directory' || this.$route.name === 'users'
		}
	},

	created() {
		if (this.tags.length === 0 || this.chaptersList.length === 0) {
			this.fetchChapters()
		}
	},
	beforeDestroy() {
		this.clearTags()
		this.clearEventCategories()
	}
}
</script>

<style lang='scss'>
.post-filter-modal {
	border-radius: 13px;
	max-height: 800px !important;
	overflow-y: hidden;

	&__container {
		max-height: 500px;
		overflow: scroll;
	}

	&__card {
		padding: 35px;
	}

	&__progress {
		position: absolute;
		left: calc(100% + 12px);
		top: 50%;
		transform: translateY(-50%);
	}

	&__title {
		position: relative;
		color: rgb(74, 74, 74);
		font-size: 24px;
		font-family: Montserrat, sans-serif;
		font-weight: bold;
		margin-bottom: 10px;
		text-transform: capitalize;
	}

	&__action-btn {
		border-radius: 8px !important;
		text-transform: capitalize;
		font-size: 16px;
		font-weight: 700;
		box-shadow: none !important;
		padding: 0 32px !important;

		@media (max-width: 480px) {
			flex-grow: 1;
			padding: 0 !important;

			&-wrapper {
				display: flex;
				flex-wrap: nowrap;
			}
		}
	}

	.action-cancel {
		background-color: #fff !important;
		color: var(--accent-color) !important;
		border: 2px solid var(--accent-color);
		margin-right: 8px;
	}

	.action-apply {
		margin-left: 8px;
	}
}

.v-picker .v-btn {
	color: black !important;
}

.v-picker .v-btn.v-btn--active {
	color: white !important;
}

.checkbox-container {
	.v-input--selection-controls__input {
		margin-right: 12px !important;
	}
}

.date-time-picker-container {
	button {
		background-color: transparent !important;
	}

	.v-card__actions {
		button {
			background-color: var(--button-main-background-color) !important;
			span {
				color: var(--button-main-color) !important;
			}
		}
	}
}
</style>
